/**
 * @param {object} obj
 * @param {string} prop
 * @returns {boolean}
 */
function hasProp (obj, prop) {
  return obj !== undefined && obj !== null && Object.prototype.hasOwnProperty.call(obj, prop)
}

module.exports = { hasProp }
